import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';

import styles from '../../../OrderStatusPage.module.scss';
import { Checkbox } from '@components';
import { useFormikContext } from 'formik';
import { ContactRowForm, NotificationType } from '../OrderStatusNotifications';

interface ContactRowProps {
  label: string;
  notificationType: NotificationType;
  onChange: (isChecked: boolean, notificationType: NotificationType) => void;
  onUpdate: (notificationType: NotificationType) => void;
  enabled: boolean;
}

export const ContactRow: FC<ContactRowProps> = ({
  label,
  notificationType,
  onChange,
  onUpdate,
  enabled,
}) => {
  const formikProps = useFormikContext<ContactRowForm>();
  const { t } = useTranslation();
  const { maskedValue, isChecked } = formikProps.values[notificationType];

  const handleOnChange = () => {
    onChange(isChecked, notificationType);
  };

  const handleOnUpdate = () => {
    if (!isChecked || !enabled) return null;

    onUpdate(notificationType);
  };

  return (
    <div className={styles.orderStatusPageContactRow}>
      <div className={styles.orderStatusPageContactContainer}>
        <Checkbox
          name={`${notificationType}.isChecked`}
          value={isChecked && enabled}
          onChange={handleOnChange}
          customIconStyles={{ marginTop: '-8px' }}
          customStyles={{
            margin: 0,
            display: 'flex',
            alignItems: 'center',
          }}
          disabled={!enabled}
        >
          <div className={styles.orderStatusPageContactLabelWrapper}>
            <div className={styles.orderStatusPageContactLabel}>{label}</div>
            {maskedValue && isChecked && enabled && (
              <div className={styles.orderStatusPageContactText}>
                {maskedValue}
              </div>
            )}
          </div>
        </Checkbox>
      </div>
      <div
        className={classnames(styles.orderStatusPageContactTrigger, {
          [styles.orderStatusPageContactTriggerDisabled]:
            !isChecked || !enabled,
        })}
        onClick={handleOnUpdate}
      >
        {t('orderStatus.notification.trigger')}
      </div>
    </div>
  );
};
